var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('model-selector',{attrs:{"trans":_vm.trans}}),_vm._v(" "),_c('choose-build-title',{attrs:{"trans":_vm.trans}}),_vm._v(" "),_c('choose-build-color',{attrs:{"trans":_vm.trans}}),_vm._v(" "),_c('choose-build-size',{attrs:{"trans":_vm.trans}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }